"use client";
import { jsx as e, Fragment as c } from "react/jsx-runtime";
import p from "clsx";
import k from "next/image";
import g from "next/link";
import { memo as o } from "react";
import { Box as f } from "../blocks/base/Base.js";
import { s as m } from "../Header.module-DzFSQ-Xi.js";
const d = o(({ children: r }) => /* @__PURE__ */ e(f, { gap: 4, row: !0, center: !0, className: m.relink, children: r }));
d.displayName = "RelinkBlock";
const u = o(
  ({ href: r, image: t, alt: l, title: a, active: s, ...n }) => {
    const i = /* @__PURE__ */ e(
      k,
      {
        src: t,
        className: p(m.relink_image, { [m.active]: s }),
        width: 32,
        height: 32,
        priority: !0,
        alt: l,
        title: a
      }
    );
    return /* @__PURE__ */ e(c, { children: r ? /* @__PURE__ */ e(g, { href: r, className: m.logo_link, ...n, children: i }) : i });
  }
);
u.displayName = "RelinkImage";
export {
  d as RelinkBlock,
  u as RelinkImage
};
